module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('div', {
    staticClass: "c-loading"
  }, [_c('div', {
    staticClass: "c-loading__text"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__orbits"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__progress"
  }, [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "c-loading__tips"
  }, [_vm._v("打开声音体验更佳")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0d9e2e84"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Loading.vue
// module id = 198
// module chunks = 1